import { Classes, Overlay } from '@blueprintjs/core'
import CX from 'classnames'
import React from 'react'

// overlayprops are just blueprint overlay props

export default ({ children, overlayProps }) => (
  <Overlay {...overlayProps} enforceFocus={false} hasBackdrop={false}>
    <div className={CX('pop-in-transition', Classes.CARD, Classes.ELEVATION_3)}>{children}</div>
  </Overlay>
)
